/**
 * InfoTooltip Component
 *
 * Small info (i) icon that reveals a text popover on hover/click.
 * Extracted from the dashboard "Min familie" card (FamilyCard.jsx) so the same
 * pattern can be reused across the app (e.g. wizard field labels) without
 * duplicating the markup/state.
 *
 * Behaviour mirrors the original FamilyCard tooltip:
 * - reveals on mouse enter, hides on mouse leave
 * - click toggles (so it works on touch / mobile)
 * - FaInfoCircle trigger, white popover with border + shadow
 */

import React, { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const InfoTooltip = ({ text, label = 'Mer informasjon', className = '' }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={`relative flex-shrink-0 ${className}`}>
      <button
        type="button"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip((v) => !v)}
        className="text-text-muted hover:text-sage-600 transition-colors"
        aria-label={label}
      >
        <FaInfoCircle className="w-3.5 h-3.5" />
      </button>

      {showTooltip && (
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-white border border-border rounded-lg shadow-lg z-50 p-3">
          <p className="text-xs text-text-secondary leading-relaxed">
            {text}
          </p>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
